// extracted by mini-css-extract-plugin
export default {"price":"o7-z","priceRow":"p7-z","onSale":"q7-z","msrpLabelPrice":"r7-z","msrpLabel":"s7-z","originalPrice":"t7-z","percentOff":"u7-z"};